import { ProfileStatusType } from '~/enums/accounts/profile-status-type.enum';

const {
  Denied,
  Rejected,
  IdentityVerificationInProgress,
  IdentityVerificationAbandoned,
  IdentityVerificationError,
  IdentityVerificationInError,
  InformationCollectionInProgress,
  AwaitingInformation,
  UnderAnalysis,
  CreationInProgress
} = ProfileStatusType;

export type TimelineStatusMap = {
  [key: string]: ProfileStatusType[];
};

export const timelineStatusMap: { [key: string]: TimelineStatusMap } = {
  informationCollection: {
    todo: [AwaitingInformation],
    progress: [InformationCollectionInProgress]
  },
  idVerification: {
    todo: [AwaitingInformation, InformationCollectionInProgress],
    progress: [
      IdentityVerificationInProgress,
      IdentityVerificationAbandoned,
      IdentityVerificationError
    ],
    problem: [IdentityVerificationInError]
  },
  businessRelationshipReview: {
    todo: [
      IdentityVerificationInProgress,
      IdentityVerificationAbandoned,
      IdentityVerificationError,
      IdentityVerificationInError,
      InformationCollectionInProgress,
      AwaitingInformation
    ],
    progress: [UnderAnalysis],
    problem: [Rejected],
    'danger-error': [Denied]
  },
  userReview: {
    todo: [CreationInProgress],
    progress: [
      UnderAnalysis,
      IdentityVerificationInProgress,
      IdentityVerificationAbandoned,
      IdentityVerificationError,
      IdentityVerificationInError,
      InformationCollectionInProgress,
      AwaitingInformation,
      Rejected
    ],
    'danger-error': [Denied]
  }
};
